import { observer } from 'mobx-react-lite'
import { useToggle } from '@/hooks/state-hooks'
import { FilterControlsContainer } from '@/components/FilterControls/FilterControlsContainer'
import { TableSearchbar } from '@/components/TableSearchbar'
import { type ClientUserManagementViewModel } from '@/features/client-user-management/ClientUserManagement/ClientUserManagementViewModel'

export interface ClientUserManagementTableControlsContainerProps {
  vm: ClientUserManagementViewModel
}

export const ClientUserManagementTableControlsContainer = observer(
  function ClientUserManagementTableControlsContainer({
    vm,
  }: ClientUserManagementTableControlsContainerProps) {
    const userSearchVm = vm.userSearch
    const hasFilters = userSearchVm.filters.appliedFilterCount > 0
    const showingFilterControls = useToggle(hasFilters)

    return (
      <>
        <TableSearchbar
          isDisabled={false}
          searchText={userSearchVm.searchText.value}
          onSearchTextChange={userSearchVm.searchText.change}
        />

        <FilterControlsContainer
          active={showingFilterControls.isEnabled}
          vm={userSearchVm.filters}
          editorTestId="job"
          testId="job-filter"
        />
      </>
    )
  },
)
